module.exports = __webpack_public_path__ + "img/157.ca2462cb.jpg";